(function () {
    'use strict';

    var app = angular.module('app');


    //*************************************************************
    /* Direttive create per verifica del funzionamento e dell'inclusione     */
    //*************************************************************
    app.directive('myCustomer', function () {
        return {
            template: 'Name: NOME Address: INDIRIZZO'
        };
    });

    app.directive('lunghezza', function () {
        var directive = {
            require: 'ngModel',
            link: link
        }
        return directive;

        function link(scope, elm, attrs, ctrl) {

            function validate(value) {
                if (value == null) return false;

                if (value.length > 3) {
                    ctrl.$setValidity('lunghezza', true);
                    return true;
                } else {
                    ctrl.$setValidity('lunghezza', false);
                    return false;
                }
            }

            scope.$watch(function () {
                return ctrl.$viewValue;
            }, validate);
        }
    });

    app.directive('imageLoader', function () {
        return {
            restrict: "E",
            scope: {
                dim: '=dim'
            },
            templareUrl: '/app/common/loader.html'
        }
    });

    app.directive('ccImageLoader', function () {
        var directive = {};

        directive.restrict = 'E'; /* restrict this directive to elements */
        directive.transclude = true;
        directive.templateUrl = "/app/html-templates/loader.html";

        return directive;
    });
    //*************************************************************

    app.directive('typeaheadCheckId', function () {
        //Usage:
        //Controlla che l'oggetto abbia una prorpietà Id
        var directive = {
            require: 'ngModel',
            link: link
        }
        return directive;

        function link(scope, elm, attrs, ctrl) {

            function validate(value) {
                var isValid = false;

                if (value == null) {
                    return false;
                }

                if (value.Id) {
                    isValid = true;
                }

                ctrl.$setValidity('typeaheadCheckId', isValid);
                return isValid;
            }

            scope.$watch(function () {
                return ctrl.$modelValue;
            }, validate);
        }
    });

    app.directive('ccImgPerson', ['config', function (config) {
        //Usage:
        //<img data-cc-img-person="{{s.speaker.imageSource}}"/>
        var basePath = config.imageSettings.imageBasePath;
        var unknownImage = config.imageSettings.unknownPersonImageSource;
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            attrs.$observe('ccImgPerson', function (value) {
                value = basePath + (value || unknownImage);
                attrs.$set('src', value);
            });
        }
    }]);

    app.directive('ccSidebar', function () {
        // Opens and clsoes the sidebar menu.
        // Usage:
        //  <div data-cc-sidebar>
        // Creates:
        //  <div data-cc-sidebar class="sidebar">
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            var $sidebarInner = element.find('.sidebar-inner');
            var $dropdownElement = element.find('.sidebar-dropdown a');
            element.addClass('sidebar');
            $dropdownElement.click(dropdown);

            function dropdown(e) {
                var dropClass = 'dropy';
                e.preventDefault();
                if (!$dropdownElement.hasClass(dropClass)) {
                    hideAllSidebars();
                    $sidebarInner.slideDown(350);
                    $dropdownElement.addClass(dropClass);
                } else if ($dropdownElement.hasClass(dropClass)) {
                    $dropdownElement.removeClass(dropClass);
                    $sidebarInner.slideUp(350);
                }

                function hideAllSidebars() {
                    $sidebarInner.slideUp(350);
                    $('.sidebar-dropdown a').removeClass(dropClass);
                }
            }
        }
    });

    app.directive('ccWidgetClose', function () {
        // Usage:
        // <a data-cc-widget-close></a>
        // Creates:
        // <a data-cc-widget-close="" href="#" class="wclose">
        //     <i class="fa fa-remove"></i>
        // </a>
        var directive = {
            link: link,
            template: '<i class="fa fa-remove"></i>',
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            attrs.$set('href', '#');
            attrs.$set('wclose');
            element.click(close);

            function close(e) {
                e.preventDefault();
                element.parent().parent().parent().hide(100);
            }
        }
    });

    app.directive('ccWidgetMinimize', function () {
        // Usage:
        // <a data-cc-widget-minimize></a>
        // Creates:
        // <a data-cc-widget-minimize="" href="#"><i class="fa fa-chevron-up"></i></a>
        var directive = {
            link: link,
            template: '<i class="fa fa-chevron-up"></i>',
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            //$('body').on('click', '.widget .wminimize', minimize);
            attrs.$set('href', '#');
            attrs.$set('wminimize');
            element.click(minimize);

            function minimize(e) {
                e.preventDefault();
                var $wcontent = element.parent().parent().next('.widget-content');
                var iElement = element.children('i');
                if ($wcontent.is(':visible')) {
                    iElement.removeClass('fa fa-chevron-up');
                    iElement.addClass('fa fa-chevron-down');
                } else {
                    iElement.removeClass('fa fa-chevron-down');
                    iElement.addClass('fa fa-chevron-up');
                }
                $wcontent.toggle(500);
            }
        }
    });

    app.directive('ccScrollToTop', ['$window', function ($window) {
        // Usage:
        // <span data-cc-scroll-to-top></span>
        // Creates:
        // <span data-cc-scroll-to-top="" class="totop">
        //      <a href="#"><i class="fa fa-chevron-up"></i></a>
        // </span>
        var directive = {
            link: link,
            template: '<a href="#"><i class="fa fa-chevron-up"></i></a>',
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            var $win = $($window);
            element.addClass('totop');
            $win.scroll(toggleIcon);

            element.find('a').click(function (e) {
                e.preventDefault();
                // Learning Point: $anchorScroll works, but no animation
                //$anchorScroll();
                $('body').animate({ scrollTop: 0 }, 500);
            });

            function toggleIcon() {
                $win.scrollTop() > 300 ? element.slideDown() : element.slideUp();
            }
        }
    }]);

    app.directive('ccSpinner', ['$window', function ($window) {
        // Description:
        //  Creates a new Spinner and sets its options
        // Usage:
        //  <div data-cc-spinner="vm.spinnerOptions"></div>
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            scope.spinner = null;
            scope.$watch(attrs.ccSpinner, function (options) {
                if (scope.spinner) {
                    scope.spinner.stop();
                }
                scope.spinner = new $window.Spinner(options);
                scope.spinner.spin(element[0]);
            }, true);
        }
    }]);

    app.directive('ccWidgetHeader', function () {
        //Usage:
        //<div data-cc-widget-header title="vm.map.title"></div>
        var directive = {
            link: link,
            scope: {
                'title': '@',
                'subtitle': '@',
                'rightText': '@',
                'allowCollapse': '@'
            },
            templateUrl: '/app/layout/widgetheader.html',
            restrict: 'A',
        };
        return directive;

        function link(scope, element, attrs) {
            attrs.$set('class', 'widget-head');
        }
    });

    app.directive('crop', ['$window', function ($window) {
        // Description:
        //  Creates a new Spinner and sets its options
        // Usage:
        //  <div data-cc-spinner="vm.spinnerOptions"></div>
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            //angular.element(element[0]).querySelector('#fileInput');

            //console.dir($window.document.querySelector('#fileInput'));


            var handleFileSelect = function (evt) {
                console.log('handleFileSelect');
                var file = evt.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (evt) {
                    scope.$apply(function (scope) {
                        scope.myImage = evt.target.result;
                        scope.cropper.sourceImage = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };

            angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
        }
    }]);


    app.directive('imageonload', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.bind('load', function () {
                    //call the function that was passed
                    scope.$apply(attrs.imageonload);
                });
            }
        };
    });

    //-------- POPOVER --------------
    app.directive('toggle', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (attrs.toggle == "tooltip") {
                    $(element).tooltip();
                }
                if (attrs.toggle == "popover") {
                    $(element).popover();
                }
            }
        };
    });

    //------------ TEXT FORMAT - PADDING
    app.filter('padding', function () {
        return function (input, len, pad) {
            input = input.toString();
            if (input.length >= len) return input;
            else {
                pad = (pad || 0).toString();
                return new Array(1 + len - input.length).join(pad) + input;
            }
        };
    });

    /*
    app.directive('minutesInput2', function () {
        return {
            restrict: 'A',
            link: function (scope, el, at) {
                scope.$watch(at.ngModel, function (input) {           
                    var pad = (at.minutesInput2 || 0).toString();
                    var padChar = pad[0];
                    if (typeof (input) == 'undefined')
                        input = '';
                    else
                        input = input.toString();

                    var result = '';
                    if (input.length >= pad.length) result = parseInt(input).toString();
                    else {
                        result = new Array(1 + pad.length - input.length).join(padChar) + input
                        //result = (at.minutesInput2 + parseInt(input)).slice(-at.length);
                    }
                    el.val(result);
                });
                
            }
        };
    });
    
    //------------ TEXT FORMAT - PADDING
    app.directive('minutesInput', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelController) {
                element.blur(function () {
                    var input = ngModelController.$viewValue;
                    if (typeof (input) == 'undefined') return;
                    var len = 2;
                    input = input.toString();
                    if (input.length < len) {
                        var pad = (0).toString();
                        input = new Array(1 + len - input.length).join(pad) + input;
                    } else {
                        if (!isNaN(parseFloat(input)) && isFinite(input))
                            input = parseInt(input);
                    }
                    ngModelController.$setViewValue(input);
                    ngModelController.$render();
                });
            }
        };
    });
    */
    /*
    app.directive('elemReady', function ($parse) {
        return {
            restrict: 'A',
            link: function ($scope, elem, attrs) {
                elem.ready(function () {
                    $scope.$apply(function () {
                        //console.info('elemReady', elem, attrs);
                        var func = $parse(attrs.elemReady);
                        func($scope, attrs.myIndex);
                    })
                });
            }
        };
    });
    */

    //*************************************************************
    /* Direttive create per gestire il messaggio di conferma "salvataggio dati" prima della navigazione in altre pagine     */
    //*************************************************************
    angular.module('app').directive('formInit', function () {
        return {
            restrict: 'A',
            scope: {
                init: '&formInit'
            },
            controller: function ($scope, $element) {
                var name = null;
                if ($element[0] && $element[0].name) {
                    name = $element[0].name;
                }

                var listener = $scope.$watch('init', function () {
                    if ($scope[name] && $scope.init) {
                        $scope.init();
                        listener();
                    }
                });
            }
        };
    });

    //*************************************************************
    /* Direttive create per gestire il messaggio di conferma "salvataggio dati" prima della navigazione in altre pagine     */
    //*************************************************************
    angular.module('app').directive("fileread", [function () {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                console.log('DIRECTIVE: fileread')
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            console.log('DIRECTIVE: fileread')
                            scope.fileread = loadEvent.target.result;
                        });
                    };
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        };
    }]);

    angular.module('app').directive('clickme', function () {
        return function (scope, element, attrs) {
            var clickingCallback = function () {
                $("#image_file").trigger('click');
            };
            element.bind('click', clickingCallback);
        };
    });



    //*************************************************************
    /* Order List                                               */
    /* Ordinamento delle liste tramite click sulle colonne      */
    //*************************************************************
    angular.module('app').directive('orderme', function () {
        return function (scope, element, attr) {
            var cssOrderedColumn = 'orderedColumn';
            var object_type = 'span';
            var cssBase = 'fa';
            var cssAsc = 'fa-arrow-down';
            var cssDesc = 'fa-arrow-up';
            var cssColumnIcon = 'orderedColumnIcon';
            var suffixKeywordDesc = 'desc';

            var clickingCallback = function () {
                var vm = scope.$parent.vm;
                var ordine_prec = vm.ordine;
                var column_name = $(element).text();//$(element).attr("headers");



                //Verifico se esiste lo SPAN nella colonna selezionata ed eventualmente lo creo
                var span = {};
                if ($(element).find(object_type).length > 0) {
                    //console.info('span exists', $(element).find("span"));
                    span = $(element).find(object_type)[0];
                } else {
                    //console.log('span not exists');
                    span = document.createElement(object_type);
                    $(element).append(span);
                }


                //Se è già ordinato, inverto l'ordine di selezione
                if (vm.ordine == column_name) {
                    vm.ordine = vm.ordine + ' ' + suffixKeywordDesc;
                    span.classList.remove(cssAsc);
                    span.classList.add(cssDesc);
                } else {
                    vm.ordine = column_name;
                    span.classList.add(cssColumnIcon);
                    span.classList.add(cssBase);
                    span.classList.add(cssAsc);
                }

                //Se precedentemente c'era già una colonna selezionata rimuovo la classe dallo span
                $(element).parent().children().each(function (index, currentElem) {
                    if ($(currentElem).text() != column_name) {
                        $(currentElem).children().remove();
                    }
                });

                if (ordine_prec != vm.ordine) { vm.cerca(); }

            };
            element.bind('click', clickingCallback);
            element.addClass(cssOrderedColumn);
            //$compile(element)(scope);
        };
    });

    //----COUNT-DOWN
    app.directive('countdown', ['$interval', function ($interval) {
        console.log('countdown');
        return {
            restrict: 'E',
            scope: {
                targetDate: '@',
                finishText: '@',
                successText: '@',
                onFinish: '&',
                isSubmitted: '=' // nuovo attributo per indicare se è stato presentato
            },
            template:
                '<div class="countdown-container text-right">' +
                '<div ng-if="!isFinished && !isSubmitted" class="compact-countdown">' +
                '<div class="countdown-unit">' +
                '<span class="countdown-value">{{days}}</span>' +
                '<span class="countdown-label">g</span>' +
                '</div>' +
                '<div class="countdown-unit">' +
                '<span class="countdown-value">{{hours}}</span>' +
                '<span class="countdown-label">h</span>' +
                '</div>' +
                '<div class="countdown-unit">' +
                '<span class="countdown-value">{{minutes}}</span>' +
                '<span class="countdown-label">m</span>' +
                '</div>' +
                '<div class="countdown-unit">' +
                '<span class="countdown-value">{{seconds}}</span>' +
                '<span class="countdown-label">s</span>' +
                '</div>' +
                '</div>' +
                '<div ng-if="isSubmitted" class="text-right">' +
                '<span class="label label-success">{{successText}}</span>' +
                '</div>' +
                '<div ng-if="isFinished && !isSubmitted" class="text-right">' +
                '<span class="label label-danger">{{finishText}}</span>' +
                '</div>' +
                '</div>',
            link: function (scope, element) {
                var timer;

                function updateTime() {
                    // Se è già stato presentato, non aggiornare il countdown
                    if (scope.isSubmitted) {
                        if (timer) {
                            $interval.cancel(timer);
                        }
                        return;
                    }

                    var current = new Date().getTime();
                    var target = new Date(scope.targetDate).getTime();
                    var diff = target - current;

                    if (diff <= 0) {
                        scope.days = 0;
                        scope.hours = 0;
                        scope.minutes = 0;
                        scope.seconds = 0;
                        scope.isFinished = true;
                        if (angular.isDefined(scope.onFinish)) {
                            scope.onFinish();
                        }
                        $interval.cancel(timer);
                        return;
                    }

                    scope.days = Math.floor(diff / (1000 * 60 * 60 * 24));
                    scope.hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    scope.minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                    scope.seconds = Math.floor((diff % (1000 * 60)) / 1000);
                }

                // Inizializzazione
                scope.isFinished = false;
                scope.finishText = scope.finishText || 'Tempo terminato!';
                scope.successText = scope.successText || 'Presentato in tempo!';
                scope.isSubmitted = scope.isSubmitted || false;

                // Avvia il timer solo se non è già stato presentato
                if (!scope.isSubmitted) {
                    timer = $interval(updateTime, 1000);
                    updateTime(); // Prima esecuzione immediata
                }

                // Osserva i cambiamenti di isSubmitted
                scope.$watch('isSubmitted', function (newVal, oldVal) {
                    if (newVal && !oldVal && timer) {
                        $interval.cancel(timer);
                    }
                });

                scope.$on('$destroy', function () {
                    if (timer) {
                        $interval.cancel(timer);
                    }
                });
            }
        };
    }]);


    //*************************************************************
    /* Direttiva per just gage                                   */
    /* I nomi devono essere in minuscolo                         */
    //*************************************************************
    angular.module('app').directive('justgage',
        function () {
            return {
                restrict: 'EAC',
                scope: {
                    title: '@',                       // gauge title text
                    titlefontcolor: '@',              // title text color

                    value: '@',                       // value to show
                    valuefontcolor: '@',              // color of value text

                    width: '@',                       // gauge width
                    height: '@',                      // gauge height
                    relativegaugesize: '@',           // true if the gauge has to grow with the container

                    min: '@',                         // minimum value
                    max: '@',                         // maximum value

                    valueminfontsize: '@',            // absolute minimum font size for the value
                    titleminfontsize: '@',            // absolute minimum font size for the title
                    labelminfontsize: '@',            // absolute minimum font size for the label
                    minlabelminfontsize: '@',         // absolute minimum font size for the minimum label
                    maxlabelminfontsize: '@',         // absolute minimum font size for the maximum label

                    hidevalue: '@',                   // hide value text
                    hideminmax: '@',                  // hide min and max values
                    hideinnershadow: '@',             // hide inner shadow

                    gaugewidthscale: '@',             // width of the gauge element
                    gaugecolor: '@',                  // background color of gauge element

                    showinnershadow: '@',             // true to display inner shadow
                    shadowopacity: '@',               // shadow opacity, values 0 ~ 1
                    shadowsize: '@',                  // inner shadow size
                    shadowverticaloffset: '@',        // how much is shadow offset from top

                    levelcolors: '@',                 // array of strings, colors of indicator, from lower to upper, in hex format
                    customsectors: '@',               // Array of objects with color, hi, lo attributes
                    nogradient: '@',                  // true to use sector-based color change, false to use gradual color change

                    label: '@',                       // text to show below value
                    labelfontcolor: '@',              // color of label under the value

                    startanimationtTime: '@',          // length of initial load animation
                    startanimationtype: '@',          // type of initial animation (linear, >, <, <>, bounce)
                    refreshanimationtime: '@',        // length of refresh animation
                    refreshanimationtype: '@',        // type of refresh animation (linear, >, <, <>, bounce)

                    donut: '@',                       // Turn the gauge into a full circle donut
                    donutstartangle: '@',             // angle to start from when in donut mode

                    counter: '@',                     // Increase numbers one by one
                    decimals: '@',                    // Quantity of decimal numbers to show
                    symbol: '@',                      // Unit of measure that will be appended to value
                    formatnumber: '@',                // Whether to format numbers
                    humanfriendly: '@',               // true to show shorthand big numbers (300K instead of 300XXX)
                    humanfriendlydecimal: '@',        // number of decimal places for our human friendly number to contain

                    textrenderer: '&'                 // function applied before rendering text
                },
                controller: 'justgageCtrl',
                link: function (scope, element, attrs, justgageCtrl) {
                    var justgage,
                        watchers = [];

                    /**
                     * Bind the `value` property on the scope in order to refresh the JustGage when it changes.
                     */
                    var bindValue = function () {
                        watchers.push(scope.$watch('value', function (newValue, oldValue) {
                            if (newValue !== oldValue) {
                                justgage.refresh(newValue, scope.max);
                            }
                        }));
                        watchers.push(scope.$watch('max', function (newValue, oldValue) {
                            if (newValue !== oldValue) {
                                justgage.refresh(scope.value, newValue);
                            }
                        }));
                    };

                    /**
                     * Bind all scope paramenters other than `value` and `textRenderer` and re-creates the JustGage whenever
                     * one of them changes.
                     */
                    var bindOtherOptions = function () {
                        var otherOptionsNames = justgageCtrl.getOptionsNames(['value', 'max']);
                        // TODO: move to angularjs 1.3 and replace with $watchGroup
                        angular.forEach(otherOptionsNames, function (name) {
                            watchers.push(scope.$watch(name, function (newValue, oldValue) {
                                if (newValue !== oldValue) {
                                    init();
                                }
                            }));
                        });
                    };

                    /**
                     * Initialize the JustGage element with the given non-undefined options on the scope.
                     * It also binds the scope values to appropriate changes
                     */
                    var init = function () {
                        var justgageOptions = {
                            parentNode: element[0]
                        };
                        angular.extend(justgageOptions, justgageCtrl.getDefinedOptions());

                        // Remove existing canvas from DOM (if any)
                        if (justgage) {
                            var canvasDom = justgage.canvas.canvas;
                            canvasDom.parentNode.removeChild(canvasDom);
                        }

                        // Clear existing watcher (see http://stackoverflow.com/a/17306971 why while & pop)
                        while (watchers.length > 0) {
                            var watcher = watchers.pop();
                            watcher();
                        }

                        // rebuild the gage
                        //console.dir(justgageOptions);
                        justgage = new JustGage(justgageOptions);

                        // Bind scope changes to element methods
                        bindValue();
                        bindOtherOptions();
                    };

                    // Initialize everything on the next $digest cycle
                    init();
                }
            };
        });

})();